import { createContext } from 'react';

export interface AppContext {
  csrfParamName: string;
  csrfToken: string;
}

export const SearchCtx = createContext<AppContext>({
  csrfParamName: '',
  csrfToken: '',
});

export function readContextFromPage(el: HTMLElement): AppContext {
  return {
    csrfParamName: el.dataset.csrfParam ?? 'csrf-token',
    csrfToken: el.dataset.csrfToken ?? '',
  };
}
